<div style="display: flex;flex-direction: row;justify-content: space-between;">
<p>{{data.obj.Message}}</p>
<img (click)="close()" src="assets/cancel.svg">
</div>
<p>Username: {{data.obj.username}}</p>
<p>Password: {{data.obj.password}}</p>
<div>
    <button class="btn btn-primary" (click)="close()" style="float: right;">OK</button>
</div>